// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2767":"aff21fd3","3101":"3ab583ea","5813":"a9cc253f","5957":"d8d59d19","8293":"3ab583ea","8372":"3ab583ea"}[chunkId] + ".chunk.css";
};